import { LORAX, LORAX_LIGHT } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import { AppPersonalizationTitle } from './AppPersonalizationTitle';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppPersonalizationVariant2 = () => {
  const StyledAppPersonalizationTile = styled(UITile).withConfig({
    displayName: "AppPersonalizationVariant2__StyledAppPersonalizationTile",
    componentId: "sc-15fgwnw-0"
  })(["background-color:", ";border-color:", ";max-width:350px;> *{padding:8px 8px 8px 20px;display:flex;}h6{line-height:1;padding:4px;}ul{padding-left:20px;}"], LORAX_LIGHT, LORAX);
  return /*#__PURE__*/_jsx(StyledAppPersonalizationTile, {
    compact: true,
    "data-test-id": "conv-0002-variant2",
    children: /*#__PURE__*/_jsx(AppPersonalizationTitle, {})
  });
};